require('./product-brands-new-container.scss')

module.exports = {
  template: require('./product-brands-new-container.pug')()
  controller: require('./product-brands-new-container.ctrl')
}
